"use client";
import { XLogo } from "@/components/icons";
import { SOCIAL_LINK_ERROR_MESSAGES } from "@/constants";
import {
  Action,
  ControlType,
} from "@/context/AnalyticsProvider/AnalyticsProvider";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import { useGameDetailsContext } from "@/context/GameDetailsContext";
import { useGameOnboardingContext } from "@/context/GameOnboardingContext";
import { useCallback, useEffect, useMemo } from "react";
import { GlassButton } from "../GlassButton";
import type { GPOnboardingStepProps } from "./utils";

export const FollowOnX = ({
  onNext,
  isVisible,
  track,
}: GPOnboardingStepProps) => {
  const { startSocialQuest, questState } = useGameOnboardingContext();
  const { allQuests, gameData } = useGameDetailsContext();
  const followXAccountQuest = useMemo(
    () => allQuests?.find((quest) => quest.type === "follow_x_account"),
    [allQuests],
  );
  useEffect(() => {
    if (!isVisible) return;
    if (
      questState?.quest.type === "follow_x_account" &&
      questState?.state === "success"
    ) {
      track({
        action: Action.SUCCEEDED,
        extras: {
          control: "follow-on-x",
          section: GamePageSection.ONBOARDING_MODAL,
        },
      });
      onNext();
    }
  }, [questState, onNext, isVisible, track]);

  const handleClick = useCallback(() => {
    if (!followXAccountQuest) return;
    startSocialQuest(gameData, followXAccountQuest);
    track({
      action: Action.PRESSED,
      extras: {
        control: "follow-on-x",
        controlLabel: "Follow on X",
        controlType: ControlType.BUTTON,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });
  }, [followXAccountQuest, startSocialQuest, track, gameData]);

  useEffect(() => {
    if (!questState?.error) return;

    track({
      action: Action.FAILED,
      extras: {
        control: "follow-on-x",
        controlLabel: questState.error,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });
  }, [questState, track]);

  return (
    <div className="flex-grow flex flex-col items-center justify-between gap-y-10">
      {/* Title */}
      <div>
        <h2 className="text-[clamp(1.25rem,6.25vw,1.875rem)] font-bold leading-[clamp(1.5rem,6.25vw,2.25rem)] text-center">
          Upgrade to a Gold reward by following Pokerist
        </h2>
      </div>

      {!questState?.error ? null : questState.error ===
        SOCIAL_LINK_ERROR_MESSAGES.SOCIAL_ACCOUNT_ALREADY_LINKED ? (
        <p className="text-sm text-red-500">
          {SOCIAL_LINK_ERROR_MESSAGES.SOCIAL_ACCOUNT_ALREADY_LINKED}
        </p>
      ) : (
        <p className="text-sm text-red-500">
          Something went wrong, please try again.
        </p>
      )}

      {/* Buttons */}
      <div className="flex flex-col items-center gap-y-10">
        <GlassButton
          control="follow-on-x-button"
          section={GamePageSection.ONBOARDING_MODAL}
          onClick={handleClick}
          variant="cta"
          className="!h-auto w-full px-20 py-3 mt-2 min-h-[3rem]"
        >
          <XLogo className="mr-2" />
          Follow on X
        </GlassButton>
        {/* <Button
          variant="ghost"
          size="lg"
          className="h-12 px-6 text-sm text-muted-foreground"
          onClick={onNext}
        >
          Not now
        </Button> */}
      </div>
    </div>
  );
};
